/**
 *
 * @module streamSampleClientPayload
 *
 */

import Check from 'check-types';
import InvalidArgumentException from '../../exception/invalidArgumentException';

const {
    number,
    string
} = Check.assert;

/**
 *
 * @class StreamSampleClientPayload
 * @since 3.5.0
 *
 */
export default class StreamSampleClientPayload {

    /**
     *
     * @param {String} event
     * @param {String} timestamp
     * @param {String} playback_session_id
     * @param {Number} play_head
     * @param {Number} bitrate
     * @throws {InvalidArgumentException}
     *
     */
    constructor(eventString, timestamp, playbackSessionId, playHead, bitrate) {

        const errorMessage = {
            ctor: 'StreamSampleClientPayload(eventString, timestamp, playback_session_id, play_head, bitrate)',
            get eventString() {
                return `${this.ctor} eventString needs to be a String`;
            },
            get timestamp() {
                return `${this.ctor} timestamp needs to be a Number`;
            },
            get playbackSessionId() {
                return `${this.ctor} playbackSessionId needs to be a String`;
            },
            get playHead() {
                return `${this.ctor} playHead needs to be Number`;
            },
            get bitrate() {
                return `${this.ctor} bitrate needs to be an Number`;
            }
        };

        string(eventString, errorMessage.eventString, InvalidArgumentException);
        number(timestamp, errorMessage.timestamp, InvalidArgumentException);
        string(playbackSessionId, errorMessage.playbackSessionId, InvalidArgumentException);

        if (Check.assigned(playHead)) {
            number(playHead, errorMessage.playHead, InvalidArgumentException);
        }

        if (Check.assigned(bitrate)) {
            number(bitrate, errorMessage.bitrate, InvalidArgumentException);
        }

        /**
         *
         * @access private
         * @type {String}
         *
         */
        this.event = eventString;

        /**
         *
         * @access private
         * @type {String}
         *
         */
        this.timestamp = timestamp;

        /**
         *
         * @access private
         * @type {String}
         *
         */
        this.play_head = playHead || 0;

        /**
         *
         * @access private
         * @type {Number}
         *
         */
        this.playback_session_id = playbackSessionId;

        /**
         *
         * @access private
         * @type {Number}
         *
         */
        this.bitrate = bitrate || 0;

    }

}



// WEBPACK FOOTER //
// ./src/services/internal/telemetry/streamSampleClientPayload.js